<template>
  <div class="about">
		<div class="pg-header">
			<div>
				<label class="title">错误日志</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>系统管理</span>|
					<span class="active">错误日志</span>
				</div>
			</div>
		</div>
		<div class="collapse-wrap">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<label>日期
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.date" :picker-options="pickerOptions" @change="handleFilter(0, $event)"></el-date-picker>
						</label>
						<label>错误提示
							<el-input size="small" placeholder="错误提示" clearable v-model="filter.message" @change="handleFilter(1, $event)"></el-input>
						</label>
						<div style="display: inline-block;">错误类型
							<el-select size="small" filterable clearable v-model="filter.type" placeholder="请选择" @change="handleFilter(1, $event)">
								<el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</div>
						<div style="display: inline-block;">来源
							<el-select size="small" filterable clearable v-model="filter.datasources" placeholder="请选择" @change="handleFilter(1, $event)">
								<el-option v-for="item in datasourcesList" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</div>
						<el-button size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
					</div>
				</el-form>
			</div>

			<div class="table-wrap">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
					<el-table-column prop="updateTime" label="时间" width="160"></el-table-column>
					<el-table-column prop="patientHisId" label="患者ID" width="110"></el-table-column>
					<el-table-column prop="type" label="错误类型" width="160">
						<template slot-scope="scope">
							{{typeList[scope.row.type].name}}
							<!-- <span v-if="scope.row.type == 0">数据不完整</span>
							<span v-if="scope.row.type == 1">删除状态</span>
							<span v-if="scope.row.type == 2">患者身份证号为空</span>
							<span v-if="scope.row.type == 3">患者身份证号重复</span>
							<span v-if="scope.row.type == 4">身份证号前后不一致</span> -->
						</template>
					</el-table-column>
					<el-table-column prop="message" label="错误提示"></el-table-column>
					<el-table-column prop="datasources" label="来源" width="120">
						<template slot-scope="scope">
							{{datasourcesList[scope.row.datasources].name}}
						</template>
					</el-table-column>
				</el-table>	
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>				
				
		</div>

  </div>
</template>

<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';

export default {
  mixins: [mixin],
	data(){
		return {
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null,
				summary: []
			},
			filter: {
				datasources: '',
				message: '',
				pageNumber: 1,
				pageSize: 10,
				patientHisId: '',
				type: '',
				updateDataEnd: '',
				updateDataStart: null,
			},		
			typeList: [
				{
					id:0,
					name:"数据不完整",
				},
				{
					id:1,
					name:"删除状态"
				},
				{
					id:2,
					name:"患者身份证号为空"
				},
				{
					id:3,
					name:"患者身份证重复"
				},
				{
					id:4,
					name:"身份证前后不一致"
				}
				
			],
			datasourcesList: [
				{
					id:0,
					name:"患者信息",
				},
				{
					id:1,
					name:"就诊记录",
				}
			]
		}
	},
	created() {
		this.loadList();	
	},	
	methods: {
		async loadList() {
			this.isLoading = true;
			let res = await api.getErrorMsg(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}
			console.log(res)
			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			this.list.data = res.data;
			this.isLoading = false;
		},
				getSummaries() {
					this.$nextTick(() => {
						this.$refs['multipleTable'].doLayout();
					});
					return this.list.summary;
				},		
				// 过滤条件 更改
				handleFilter(key, val) {
					switch(key) {
						case 0:
							if (this.filter.date) {
								this.filter.updateDataStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
								this.filter.updateDataEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
							} else {
								this.filter.updateDataStart = '';
								this.filter.updateDataEnd = '';						
							}
							break;
					}
					this.filter.pageNumber = 1;
					this.loadList();
				},			
				handleSizeChange(v) {
					this.filter.pageSize = v;
					this.filter.pageNumber = 1;
					this.loadList();
				},
				handleCurrentChange(v) {
					this.filter.pageNumber = v;
					this.loadList();
				},
				exportReport() {
					this.filter.pageSize=this.list.total;
					let url = api.exportStatisticsReturn(this.filter);
					const tempLink = document.createElement('a');
					tempLink.style.display = 'none';
					tempLink.href = url;
					tempLink.target = '_blank';
					document.body.appendChild(tempLink);
					tempLink.click()
					document.body.removeChild(tempLink);
			this.filter.pageSize=10;

				}
			}
		}
		</script>
		
		<style lang="less" scoped>
		@import '@/assets/style/var';
			/deep/.search-bar .el-select .el-input{
				width: 140px
			}
			/deep/.el-form .el-input{
				width: 180px
			}	
		</style>
		
